/**
 * 画布内等比适配（object-fit: contain）：宽或高之一贴满画布，不溢出，允许放大。
 */
export function computeWorkspaceContainScale(imageWidth, imageHeight, workspaceWidth, workspaceHeight) {
  const iw = Math.max(1, Number(imageWidth) || 1);
  const ih = Math.max(1, Number(imageHeight) || 1);
  const ww = Math.max(1, Number(workspaceWidth) || 1);
  const wh = Math.max(1, Number(workspaceHeight) || 1);
  return Math.min(ww / iw, wh / ih);
}

/**
 * 画布内等比铺满（object-fit: cover）：宽与高都至少贴满，可能裁切边缘，避免 JPG 合成留白边。
 */
export function computeWorkspaceCoverScale(imageWidth, imageHeight, workspaceWidth, workspaceHeight) {
  const iw = Math.max(1, Number(imageWidth) || 1);
  const ih = Math.max(1, Number(imageHeight) || 1);
  const ww = Math.max(1, Number(workspaceWidth) || 1);
  const wh = Math.max(1, Number(workspaceHeight) || 1);
  return Math.max(ww / iw, wh / ih);
}

/** fabric 工作区对象的可视宽高（未缩放前的 width/height × scale） */
export function readFabricWorkspaceSize(workspace) {
  if (!workspace) return { width: 1, height: 1 };
  if (typeof workspace.getScaledWidth === 'function' && typeof workspace.getScaledHeight === 'function') {
    return {
      width: Math.max(1, workspace.getScaledWidth()),
      height: Math.max(1, workspace.getScaledHeight()),
    };
  }
  const sx = Math.abs(Number(workspace.scaleX) || 1);
  const sy = Math.abs(Number(workspace.scaleY) || 1);
  return {
    width: Math.max(1, (Number(workspace.width) || 1) * sx),
    height: Math.max(1, (Number(workspace.height) || 1) * sy),
  };
}
